import {FC, useMemo} from "react";
import {Modal, Spin} from "antd";
import {ContactModalProps} from "./types";
import ContactForm from "./components/ContactForm";
import {ContactsOutlined} from "@ant-design/icons";
import "./components/style.less";

const ContactModal: FC<ContactModalProps> = (props) => {
  const {contactController} = props
  const {isLoading, isModalOpen, form, toggleModal, selectedContactItem} = contactController

  const title = useMemo(() => {
    return selectedContactItem ? "Редагувати контактну інформацію" : "Додати контактну інформацію"
  }, [selectedContactItem])


  return <Modal
    width={620}
    centered
    className="contact-modal"
    title={<div className="contact-modal__title">
      <span className="contact-modal__title-icon"><ContactsOutlined/></span>
      <span>
        <span className="contact-modal__title-eyebrow">Контактна інформація</span>
        <span className="contact-modal__title-text">{title}</span>
      </span>
    </div>}
    open={isModalOpen}
    onOk={() => form.submit()}
    onCancel={toggleModal}
    okText="Зберегти"
    cancelText="Скасувати"
    confirmLoading={isLoading}
    destroyOnClose
  >
    <Spin spinning={isLoading}>
      <ContactForm contactController={contactController}/>
    </Spin>
  </Modal>
}

export default ContactModal
